<template>
  <App v-if="isAppReady"></App>
</template>

<script>
import App from './App';

export default {
  components: {
    App,
  },
  data() {
    return {
      isAuthReady: false,
    };
  },
  mounted() {
    this.setIsAuthReady();
  },
  computed: {
    isAppReady() {
      return this.isAuthReady && this.isValidRoute;
    },
    isValidRoute() {
      return this.$route && this.$route.name;
    },
  },
  methods: {
    setIsAuthReady() {
      this.isAuthReady = Boolean(this.$auth && !this.$auth.loading);
      if (!this.isAuthReady) this.addAuthLoadingWatcher();
    },
    addAuthLoadingWatcher() {
      this.$auth.$watch('loading', (loading = true) => {
        this.isAuthReady = !loading;
      });
    },
  },
};
</script>
